import { useMemo } from 'react';

import type { CourseHomepage, UserRole } from '@/features/courses/useCourse';

type CourseRoleContext =
  | Partial<Pick<CourseHomepage, 'isInstructorView' | 'userRole'>>
  | null
  | undefined;

export function getUserRole(course: CourseRoleContext): UserRole {
  if (course?.userRole) {
    return course.userRole;
  }

  return course?.isInstructorView ? 'instructor' : 'student';
}

export function isInstructionalRole(role: UserRole) {
  return role === 'instructor' || role === 'assistant';
}

export function useUserRole(course: CourseRoleContext): UserRole {
  return useMemo(
    () => getUserRole(course),
    [course?.isInstructorView, course?.userRole],
  );
}
